import * as enums from "../enums/enums";

export const insights = (state = {}, action) => {
  switch (action.type) {
    case enums.SET_INSIGHTS_JSON:
      return action.json;

    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/insights.js